import _ from "lodash";
import { formatProjectNumber } from "../../../utils/helpers";

export const handleAssetCostData = (isAssetChecked, data) => {
  return data?.map((asset) => {
    const assetType = isAssetChecked
      ? asset?.assetDiscounted
      : asset?.assetNominal;
    const assetTotal = (
      isAssetChecked ? asset?.assetDiscountedTotal : asset?.assetNominalTotal
    )?.toFixed(2);

    const pieData = Object.entries(assetType)?.map(([key, value]) => ({
      value: value < 0 ? Math.abs(value)?.toFixed(2) : value?.toFixed(2),
      selected: value < 0 || false,
      name: key?.charAt(0).toUpperCase() + key?.slice(1),
    }));

    return {
      assetName: asset?.assetName,
      assetTotal,
      pieData,
    };
  });
};

export const COST_KEYS = [
  "incentive",
  "opex",
  "fuel",
  "salvage",
  "capex",
  "replacement",
];

export const formatValue = (value) => {
  if (!_.isNumber(value) || value === 0) return "";
  return value >= 1000
    ? formatProjectNumber(value, { maximumFractionDigits: 0 })
    : value.toFixed(3);
};

export const getSeriesData = (rawData, dataKey) =>
  COST_KEYS.map((key) => ({
    name: _.startCase(key),
    type: "bar",
    stack: "total",
    label: {
      show: true,
      formatter: ({ value }) => formatValue(value),
      fontSize: 10,
    },
    emphasis: { focus: "series" },
    data: _.map(rawData, (item) => _.get(item, [dataKey, key], 0)),
  }));

export const getCategoryLabels = (rawData, fieldName) =>
  _.map(rawData, fieldName);

const COST_TYPE_TO_KEY = {
  CAPEX: "capex",
  OPEX: "opex",
  Fuel: "fuel",
  Replacement: "replacement",
  Salvage: "salvage",
  Incentive: "incentive",
};

const emptyAssetCosts = () => ({
  salvage: 0,
  opex: 0,
  replacement: 0,
  incentive: 0,
  capex: 0,
  fuel: 0,
});

const sumValues = (values) =>
  (values || []).reduce((sum, value) => {
    const numericValue = Number(value);
    return sum + (Number.isFinite(numericValue) ? numericValue : 0);
  }, 0);

const roundTo2 = (value) => Math.round(value * 100) / 100;

// Aggregates per-year assetCashflow.assets cashflows into one total-lifetime asset object,
// shaped the same way the legacy assetsInfo API response was.
export const buildAssetsInfoFromCashflow = (assetCashflow) => {
  const assets = assetCashflow?.assets;
  if (!Array.isArray(assets)) return [];

  return assets.map((asset) => {
    const assetNominal = emptyAssetCosts();
    const assetDiscounted = emptyAssetCosts();

    (asset?.cashFlows || []).forEach((cashFlow) => {
      const key = COST_TYPE_TO_KEY[cashFlow?.costType];
      if (!key) return;
      assetNominal[key] += sumValues(cashFlow?.relativeNominalValues);
      assetDiscounted[key] += sumValues(cashFlow?.relativeDiscountedValues);
    });

    Object.keys(assetNominal).forEach((key) => {
      assetNominal[key] = roundTo2(assetNominal[key]);
      assetDiscounted[key] = roundTo2(assetDiscounted[key]);
    });

    return {
      assetName: asset?.assetType || "",
      assetNominal,
      assetDiscounted,
      assetNominalTotal: roundTo2(Object.values(assetNominal).reduce((sum, value) => sum + value, 0)),
      assetDiscountedTotal: roundTo2(Object.values(assetDiscounted).reduce((sum, value) => sum + value, 0)),
    };
  });
};
